export const HOST = window.location.origin.slice(
  0,
  window.location.origin.lastIndexOf(':')
)

export const PATH = {
  AUCTION: `${HOST}:3003/auction`,
  SESSION: `${HOST}:3001/session`,
  GUARANTEES: `${HOST}:3002/guarantee`,
  EMAIL: `${HOST}:3004/email`,
  STORAGE: `${HOST}:3005/storage`,
  REPORT: `${HOST}:3006/report`,
  SOCKET_AUCTION: `${HOST}:3101`,
  LOAD_INIT: `${HOST}:3201/loadinit`,
  INTEGRATION: `${HOST}:3005/integration`
}

export const STREAMING = {
  WEBRTC: 'ws://media.rematetattersallgda.com',
  URL: 'https://media.rematetattersallgda.com',
  RTMP: 'rtmp://rtmp.rematetattersallgda.com',
  ID_SUFFIX: 'local',
}

export const WEB = {
  BASE: window.location.host,
  HOME: '/',
  EXPIRED: '/expired',
  LOGIN_URL: 'http://localhost:3007/login?rol=true',
}
export const URL_TCIT = {
  BASE: 'https://tattersallgestiondeactivos.cl',
  URL: '/login',
}
export const BASE_URL_WEBSITE = 'http://localhost:5000'
export const BASE_URL_WEB = 'http://localhost:3007'
//export const BASE_URL_WEB = 'http://tattersallgestiondeactivos.cl'
//export const BASE_URL_WEBSITE = 'https://api.tattersallgestiondeactivos.cl'

export const NAME = 'local'
